import React from 'react'
import { Button, Segment } from 'semantic-ui-react'

import SurveyPushContactCustomFieldSetting from './SurveyPushContactCustomFieldSetting'
import ActivateIntegrationButtonSection from 'components/ActivateIntegrationButtonSection'

/**
 * @typedef {object} IntegrationSetting
 * @property {number} id
 * @property {string} name
 * @property {string} type
 * @property {boolean} is_active
 *
 * @param {object} props
 * @param {IntegrationSetting} props.integrationSetting
 * @param {function} props.activateIntegration
 * @param {function} props.deactivateIntegration
 * @param {boolean} props.updateCompanyIntegrationSettingAPILoading
 * @param {boolean} props.isAuthenticated
 * @param {array} props.surveyIntegrationSettings
 * @param {array} props.contactCustomFields
 * @param {function} props.resyncContactField
 * @param {boolean} props.resyncContactFieldLoading
 */
export default function PushContactCustomFieldIntegration({
  integrationSetting,
  activateIntegration,
  deactivateIntegration,
  updateCompanyIntegrationSettingAPILoading,
  isAuthenticated,
  surveyIntegrationSettings,
  contactCustomFields,
  resyncContactField,
  resyncContactFieldLoading,
}) {
  const isIntegrationActive = integrationSetting.is_active

  return (
    <React.Fragment>
      <div className="grid grid-cols-2 mb3">
        <div>
          <p>Map rating values to any contact custom attributes in your Intercom account.</p>
          <p>
            <a
              href="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_b39d7a39ea"
              target="_blank"
              rel="noreferrer"
            >
              <i className="icon far fa-book" />
              Learn more about updating contact custom attributes from feedback
            </a>
          </p>

          <ActivateIntegrationButtonSection
            activateIntegration={activateIntegration}
            deactivateIntegration={deactivateIntegration}
            loading={updateCompanyIntegrationSettingAPILoading}
            isAuthenticated={isAuthenticated}
            isIntegrationActive={isIntegrationActive}
            integrationType="Intercom"
          />
        </div>
        <div>
          <img
            src="https://cdn.simplesat.io/intercom/update-contact-custom-attributes-from-feedback.png"
            alt="Update contact custom attributes from feedback"
            className="ui bordered image float-right"
          />
        </div>
      </div>
      <div>
        <h4>Surveys</h4>
        <Segment.Group>
          {surveyIntegrationSettings.map((surveyIntegrationSetting, index) => (
            <SurveyPushContactCustomFieldSetting
              key={index}
              surveyIntegrationSetting={surveyIntegrationSetting}
              disabled={!isAuthenticated || !isIntegrationActive}
              contactCustomFields={contactCustomFields}
              resyncContactFieldLoading={resyncContactFieldLoading}
            />
          ))}
        </Segment.Group>
        <div className="flex justify-end">
          <Button
            basic
            onClick={resyncContactField}
            disabled={resyncContactFieldLoading || !isIntegrationActive || !isAuthenticated}
            className="m0"
          >
            <i className="far fa-sync icon" />
            Resync Intecom attributes
          </Button>
        </div>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomPushContactCustomFieldIntegration/index.js